import axios from 'axios';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { serializeAxiosError } from '../shared/reducers/reducer.utils';

const apiUrl = 'api/profase-usuario-inboxes/me/leido-counts';

export const fetchInboxLeidoCounts = createAsyncThunk(
  'profaseUsuarioInbox/fetchLeidoCounts',
  async () => {
    return axios.get<any[]>(`${apiUrl}?leidos=false&cacheBuster=${Date.now()}`);
  },
  { serializeError: serializeAxiosError },
);

const profaseUsuarioInboxSlice = createSlice({
  name: 'profaseUsuarioInbox',
  initialState: {
    leidoCounts: [] as any[],
    loadingLeidoCounts: false,
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchInboxLeidoCounts.pending, state => {
        state.loadingLeidoCounts = true;
      })
      .addCase(fetchInboxLeidoCounts.fulfilled, (state, action) => {
        state.loadingLeidoCounts = false;
        state.leidoCounts = Array.isArray(action.payload.data) ? action.payload.data : [];
      })
      .addCase(fetchInboxLeidoCounts.rejected, state => {
        state.loadingLeidoCounts = false;
        state.leidoCounts = [];
      });
  },
});

export default profaseUsuarioInboxSlice.reducer;
